import { render, staticRenderFns } from "./PageGestionOrdre.vue?vue&type=template&id=10ab51f9&scoped=true"
import script from "./PageGestionOrdre.vue?vue&type=script&lang=js"
export * from "./PageGestionOrdre.vue?vue&type=script&lang=js"
import style0 from "./PageGestionOrdre.vue?vue&type=style&index=0&id=10ab51f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ab51f9",
  null
  
)

export default component.exports